import { render } from "./Reply.vue?vue&type=template&id=d68f87fa&scoped=true"
import script from "./Reply.vue?vue&type=script&lang=js"
export * from "./Reply.vue?vue&type=script&lang=js"

import "./Reply.vue?vue&type=style&index=0&id=d68f87fa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d68f87fa"]])

export default __exports__